import { createFeatureSelector, createSelector } from '@ngrx/store';
import { CustomerState } from '../reducers/customer.reducer';
import { StateProperty } from '../reducers';

export const customersSelector = createFeatureSelector<CustomerState>(StateProperty.CUSTOMERS);

export const selectCustomers = createSelector(
  customersSelector,
  state => state.customers.map(customer => ({...customer, fullName: customer.firstname + ' ' + customer.lastname}))
);

export const selectCustomer = (id: string) => createSelector(
  customersSelector,
  state => state.customers.find(customer => customer.id === id) || (state.me?.id === id ? state.me : undefined)
);

export const selectMe = createSelector(
  customersSelector,
  state => state.me
);
